// Документы — `/org/*`. Поднимает модалки, если они есть на странице
// (на `/org/sposoby-oplaty/` — «Оплата от юрлица»).
//
// Форма модалки — `src/js/components/corporate-payment.js`.
//
// ⚠️ Модалки пока в легаси assets/js/modals/: их импортируют
// легаси-скрипты, которые грузятся без сборки. Переносить в src/,
// когда уйдёт последний из них.
export default async function PageDocuments() {
    if (!document.querySelector('.documents') || !document.querySelector('[data-modal]')) return;

    const { initModals } = await import('../../../assets/js/modals/init-modals.js');
    initModals();
}
